<template>
    <LoansList/>
</template>

<script>
import LoansList from '@/applications/final/components/list/List'
import Cookies from 'js-cookie'
import Store from '@/store'

export default {
    name: 'Loans',
    components: {
        LoansList
    },
    beforeRouteEnter(to, from, next) {
        if (Cookies.get('sbg-cpa')) {
            next()
        } else {
            Store.commit('application/load', false)
            next({ name: 'PersonalAreaServices' })
        }
    }
}
</script>